import styled from "styled-components";

export const PSSubmitCTAWrapper = styled.div`
  display: flex;
  width: 100%;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin-left: -20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5em;
  padding: 0.5em;
  background: #fff;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 3px 25px 50px rgba(0, 0, 0, 0.05);
  z-index: 50;
`;

export const BoxFullCTA = styled.button`
  width: 100%;
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? "0.5" : 1)};
  border: none;
  background: var(--accent);
  border-radius: 4px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  font-weight: 400;
  max-width: 200px;
  font-size: 16px;
  gap: 10px;
  :hover,
  :active,
  :focus {
    background-color: #19408a;
  }
  :disabled {
    background-color: #dddddd;
    color: #74797d;
  }
`;

export const SubmitCTA = styled.button`
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? "0.5" : 1)};
  border: none;
  border-radius: 4px;
  color: #fff;
  background: var(--green);
  padding: 8px 20px;
  font-weight: 400;
  max-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 16px;

  :hover,
  :active,
  :focus {
    background-color: #157a4d;
  }

  :disabled {
    background-color: #dddddd;
    color: #74797d;
  }
`;
